export class LoginOperador
{
    public Login: string = null;
    public Senha: string = null;
    public IdentificadorUsuario: number=null;
}